import {getAgentSignature} from '../../helpers/getAgentSignature';
import {QuoteTemplateParams} from '../quoteTemplateParams';
import {highlightYellow} from '../../helpers/highlightYellow';
import {getHowToReadQuotesVideo} from '../../helpers/getHowToReadQuotesVideo';
import {getNextStepsVideo} from '../../helpers/getNextStepsVideo';
import {
    emailHeaderCompanyLogo,
    quoteGreeting,
    quoteDiscussionReview,
    quoteIntroVideo,
    quoteNextSteps,
    aboutAmplify,
    illnessBrochure,
} from '../../helpers/commonEmailComponents';

export default function quoteTermNonblend(params: QuoteTemplateParams) {
    const {
        name,
        face_amount: faceAmount,
        monthly_premium: monthlyPremium,
        brochureLink,
        illnessSection,
        term_period: termPeriod,
    } = params;

    return `
${emailHeaderCompanyLogo}
<p>Hi ${highlightYellow(name)},</p>
${quoteGreeting}
${quoteDiscussionReview}
${quoteIntroVideo}
<p><strong>Our life insurance policies provide:</strong></p>
<ol>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Immediate Life Insurance Protection</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">Pays out for life, critical, chronic, and terminal illness emergencies</span></li>
</ol>
<p><strong>Life insurance plan option for</strong><strong> </strong><strong>${highlightYellow(name)}</strong></p>
<ul>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        faceAmount,
    )}</span><span style="font-weight: 400;"> life, critical, chronic, and terminal illness protection for ${highlightYellow(
        termPeriod,
    )} years</span></li>
<li style="font-weight: 400;" aria-level="1"><span style="font-weight: 400;">${highlightYellow(
        monthlyPremium,
    )} per month</span></li>
</ul>
${getHowToReadQuotesVideo(params)}
${quoteNextSteps}
${getNextStepsVideo()}
${aboutAmplify}
${illnessBrochure(illnessSection, brochureLink)}
<p><span style="font-weight: 400;">Please let me know if you have any additional questions. Otherwise looking forward to speaking with you again </span><span style="font-weight: 400;">${highlightYellow(
        'on Friday',
    )}</span><span style="font-weight: 400;"> to help you find a plan that best fits your needs.</span></p>
<p><span style="font-weight: 400;">Sincerely,</span></p>
${getAgentSignature()}
	`;
}
